export const th = {
    translation: {
        b: {
            cancel: 'ยกเลิก',
            confirm: 'ยืนยัน',
            send: 'ส่ง',
            done: 'เสร็จสิ้น',
            close: 'ปิด',
            clear: 'ล้าง',
            copy_link: 'คัดลอกลิงก์',
            export: 'ส่งออก',
            delete: 'ลบ',
            delete_confirm: 'ยืนยันการลบ',
            duplicate: 'ทำซ้ำ',
            share: 'แชร์',
            sign_in: 'ลงชื่อเข้าใช้',
            sign_up: 'สมัครสมาชิก',
            email_address: 'ที่อยู่อีเมล',
            yes: 'ใช่',
            no: 'ไม่ใช่',
            back: 'กลับ',
            upgrade: 'อัปเกรด',
            remove: 'นำออก',
            restore: 'กู้คืน',
            archive: 'เก็บถาวร',
            rename: 'เปลี่ยนชื่อ',
            leave: 'ออก',
            import: 'นำเข้า',
            continue: 'ดำเนินการต่อ',
            settings: 'การตั้งค่า',
            log_out: 'ออกจากระบบ',
            invite: 'เชิญ',
            invited: 'เชิญแล้ว',
        },
        roles: {
            view: 'ผู้ดู',
            comment: 'ผู้แสดงความคิดเห็น',
            edit: 'ผู้แก้ไข',
            admin: 'ผู้ดูแลระบบ',
            owner: 'เจ้าของ',
            member: 'สมาชิก',
            remove: 'นำออก',
            more_roles: 'บทบาทเพิ่มเติม...',
            change_role: 'เปลี่ยนบทบาท...',
            remove_access: 'ลบสิทธิ์การเข้าถึง...',
            remove_invite: 'ลบคำเชิญ...',
        },
        db_engine: {
            basic: 'SQL พื้นฐาน',
            general: 'SQL ทั่วไป',
        },
        socket_status: {
            reconnecting: 'กำลังเชื่อมต่อใหม่...',
            offline: 'คุณออฟไลน์อยู่ กำลังเชื่อมต่อใหม่...',
        },
        loader: {
            diagram: 'กำลังโหลดไดอะแกรม...',
        },
        m_languages: {
            title: 'ภาษา',
            subtitle: 'เลือกภาษา'
        },
        m_feedback: {
            feature: {
                name: 'คำขอฟีเจอร์',
                desc: 'ขาดฟีเจอร์ที่คุณต้องการอยู่หรือไม่? บอกเราได้เลย — ไอเดียของคุณสำคัญมาก'
            },
            feedback: {
                name: 'แชร์ข้อเสนอแนะของคุณ',
                desc: 'เราอยากฟังความคิดเห็นของคุณ'
            },
            support: {
                name: 'ฝ่ายสนับสนุน',
                desc: 'มีบางอย่างใช้งานไม่ได้ใช่ไหม? บอกเราได้เลย — เราจะแก้ไขให้อย่างรวดเร็ว',
            },
            bug: {
                name: 'รายงานปัญหา',
                desc: 'มีบางอย่างดูไม่ถูกต้องใช่ไหม? รายงานได้เลย — เราจะดำเนินการให้อย่างรวดเร็ว',
            },
            integration: {
                name: 'ขอการเชื่อมต่อระบบ',
                desc: 'ข้อเสนอแนะของคุณมีความหมายกับเรามาก — กรุณาฝากข้อความสั้น ๆ ไว้',
            },
        },
        m_feedback_t: {
            feature: {
                name: 'ขอบคุณสำหรับข้อเสนอแนะของคุณ!',
                desc: 'ขอบคุณที่สละเวลาแบ่งปันความคิด — สิ่งนี้ช่วยให้เราพัฒนาให้ดียิ่งขึ้น'
            },
            feedback: {
                name: 'ขอบคุณสำหรับความคิดเห็นของคุณ!',
                desc: 'ขอบคุณที่สละเวลาแบ่งปันความคิด — สิ่งนี้ช่วยให้เราพัฒนาให้ดียิ่งขึ้น'
            },
            support: {
                name: 'ขอบคุณที่ติดต่อเรา!',
                desc: 'ขอบคุณที่ติดต่อฝ่ายสนับสนุน — เราจะตรวจสอบคำขอของคุณและตอบกลับโดยเร็วที่สุด',
            },
            bug: {
                name: 'ขอบคุณสำหรับรายงานของคุณ!',
                desc: 'ขอบคุณที่รายงานปัญหานี้ — สิ่งนี้ช่วยให้เราแก้ไขปัญหาได้เร็วขึ้นและปรับปรุงประสบการณ์ใช้งานอย่างต่อเนื่อง',
            },
            contact: {
                name: 'ขอบคุณที่ติดต่อเรา!',
                desc: 'เราได้รับข้อความของคุณแล้ว และจะตอบกลับโดยเร็วที่สุด',
            },
            invite_people: {
                name: 'ส่งคำเชิญเรียบร้อยแล้ว!',
                desc: 'ขอบคุณที่ช่วยบอกต่อ — เรารู้สึกตื่นเต้นที่จะต้อนรับพวกเขา',
            },
            integration: {
                name: 'ขอบคุณสำหรับข้อเสนอแนะของคุณ!',
                desc: 'ขอบคุณที่สละเวลาแบ่งปันความคิด — สิ่งนี้ช่วยให้เราพัฒนาให้ดียิ่งขึ้น',
            },
        },
        m_diagram_details: {
            name_place: 'ป้อนชื่อโปรเจกต์',
            desc_place: 'ป้อนคำอธิบายโปรเจกต์'
        },
        m_quick_share: {
            title: 'แชร์ด่วน',
            subtitle: '(การแชร์ลิงก์แบบอิงคิวรี)'
        },
        m_export_img: {
            title: 'ส่งออกภาพ'
        },
        search_menu: {
            placeholder: 'ค้นหาตาราง คอลัมน์ ประเภท...',
            hint: '',
            no_results: 'ไม่มีผลลัพธ์',
            quick_results: 'ผลการค้นหาด่วนสำหรับ',
            untitled: 'ไม่มีชื่อ',
            command_tag: 'คำสั่ง',
            section_tables: 'ตาราง',
            section_columns: 'คอลัมน์',
            section_canvas: 'แคนวาส',
            section_export: 'ส่งออก',
            section_preferences: 'การตั้งค่าที่ต้องการ',
            section_settings: 'การตั้งค่า',
            type_table: 'ตาราง',
            type_note: 'โน้ต',
            cmd_new_table: 'สร้างตารางใหม่...',
            cmd_new_note: 'สร้างโน้ตใหม่...',
            cmd_new_line: 'สร้างเส้นใหม่...',
            cmd_new_area: 'สร้างพื้นที่ใหม่...',
            cmd_export_image: 'ส่งออกภาพ...',
            cmd_export_sql: 'ส่งออกโค้ด SQL...',
            cmd_grid_style: 'เปลี่ยนโครงตาราง...',
        },
        canvas_table: {
            more_column: 'คอลัมน์เพิ่มเติม',
            more_columns: 'คอลัมน์เพิ่มเติม',
            tooltip_table: 'ตาราง',
            tooltip_indexes: 'ดัชนี',
            tooltip_enum: 'Enum',
            tooltip_default: 'ค่าเริ่มต้น',
            tooltip_generated: 'สร้างอัตโนมัติ',
            tooltip_check: 'เงื่อนไขตรวจสอบ',
        },
        m_export_code: {
            title: 'ส่งออกโค้ด {{db_engine}}',
            download_file: 'ดาวน์โหลดไฟล์',
            copy_code: 'คัดลอกโค้ด'
        },
        m_sign_in_remind: {
            title: 'ขอบคุณที่ลองใช้ DB Design',
            subtitle: 'ลงชื่อเข้าใช้หรือสมัครสมาชิกเพื่อเพิ่มจำนวนตารางสูงสุด บันทึกไดอะแกรม และปลดล็อกฟีเจอร์เพิ่มเติม'
        },
        m_sign_in_restrict: {
            title: 'ลงชื่อเข้าเพื่อทำได้มากขึ้นในแอป',
            subtitle: 'ลงชื่อเข้าใช้หรือสมัครสมาชิกเพื่อเพิ่มขีดจำกัดของตาราง บันทึกไดอะแกรม และปลดล็อกฟีเจอร์เพิ่มเติม'
        },
        m_new_diagram: {
            title: 'ไดอะแกรมใหม่',
            subtitle: 'เลือกเอนจินฐานข้อมูล',
            open_diagram: 'เปิดไดอะแกรม',
            create_diagram: 'สร้างไดอะแกรม',
            no_workspace: 'สร้างพื้นที่ทำงานก่อนเพื่อเริ่มสร้างไดอะแกรม',
            build_something_new: 'มาสร้างสิ่งใหม่กันเถอะ',
            create_diagram_section: 'สร้างไดอะแกรม',
            clone_template_btn: 'โคลนเทมเพลต',
        },
        m_diagram_name: {
            enter_new_name: 'ป้อนชื่อไดอะแกรมใหม่',
        },
        m_diagram_clone: {
            header: 'ทำซ้ำไดอะแกรม',
            copy_of_title: 'สำเนาของ {{title}}',
        },
        m_diagram_rename: {
            header: 'เปลี่ยนชื่อไดอะแกรม',
        },
        m_template_clone: {
            header: 'สร้างไดอะแกรมจากเทมเพลต',
        },
        m_diagram_delete: {
            header: 'ลบไดอะแกรม',
            desc_prefix: 'การดำเนินการนี้จะลบ ',
        },
        m_diagram_archive: {
            header: 'เก็บถาวรไดอะแกรม',
            desc_prefix: 'การดำเนินการนี้จะเก็บถาวร ',
        },
        m_diagram_restore: {
            header: 'กู้คืนไดอะแกรม',
            desc_prefix: 'การดำเนินการนี้จะกู้คืน ',
        },
        m_diagram_import: {
            sql_name: 'นำเข้าโค้ด SQL',
            dbml_name: 'นำเข้าโค้ด DBML',
            placeholder: 'เราอยากรับฟังความคิดเห็นของคุณ!',
        },
        m_diagram_not_found: {
            header: 'ไม่พบไดอะแกรม',
            desc: 'เราไม่พบไดอะแกรมที่คุณกำลังค้นหา',
            back_to_app: 'กลับสู่แอป',
        },
        m_diagram_share: {
            header: 'แชร์ไดอะแกรม – {{title}}',
            owner_only_invite: 'เฉพาะเจ้าของเท่านั้นที่สามารถเชิญสมาชิกใหม่ได้',
            invited_to_workspace: 'ได้รับเชิญเข้าร่วมพื้นที่ทำงาน',
            you: 'คุณ',
            email_placeholder: 'ป้อนอีเมล',
            email_already_in_list: 'อีเมลนี้อยู่ในรายการแล้ว',
            will_be_invited_to_workspace: 'จะได้รับเชิญเข้าร่วมพื้นที่ทำงาน',
        },
        m_invite_people: {
            header: 'เชิญเข้าร่วมพื้นที่ทำงาน',
        },
        m_invite_revoke: {
            header: 'ลบคำเชิญ',
            desc_prefix: 'ลบคำเชิญสำหรับ ',
            desc_suffix: 'คำเชิญนี้จะใช้งานไม่ได้อีกต่อไป',
        },
        m_member_remove: {
            header: 'นำสมาชิกออก',
            desc_prefix: 'นำ ',
            desc_suffix: 'ออกจากพื้นที่ทำงานนี้หรือไม่? บุคคลนี้จะสูญเสียสิทธิ์การเข้าถึง',
        },
        m_template_details: {
            preview: 'ตัวอย่าง',
            use_template: 'ใช้เทมเพลต',
        },
        m_workspace_create: {
            header: 'สร้างพื้นที่ทำงานใหม่',
            name_label: 'ชื่อ',
            setup_config_label: 'การตั้งค่าเริ่มต้น',
            setup_config_value: 'พื้นที่ทำงานว่างเปล่า',
            template_structure_label: 'เทมเพลต/โครงสร้าง',
            template_structure_value: 'โหลดโครงสร้างล่วงหน้า',
            placeholder: 'ป้อนชื่อพื้นที่ทำงาน',
            create_button: 'สร้างพื้นที่ทำงาน',
            creating: 'กำลังสร้างพื้นที่ทำงานของคุณ...',
        },
        m_workspace_delete: {
            header: 'ลบพื้นที่ทำงาน',
            desc_prefix: 'การดำเนินการนี้จะลบ ',
            confirm_prefix: 'พิมพ์ ',
            confirm_suffix: ' เพื่อยืนยัน',
        },
        m_workspace_leave: {
            header: 'ออกจากพื้นที่ทำงาน',
            desc_prefix: 'การดำเนินการนี้จะนำคุณออกจาก ',
            desc_suffix: 'คุณจะต้องได้รับคำเชิญใหม่เพื่อเข้าร่วมอีกครั้ง',
        },
        m_workspace_menu: {
            manage_members: 'จัดการสมาชิก',
            switch_workspace: 'สลับพื้นที่ทำงาน',
            workspaces_label: 'พื้นที่ทำงาน',
            create_workspace: 'สร้างพื้นที่ทำงาน...',
            switching: 'กำลังสลับ',
        },
        m_profile_menu: {
            profile: 'โปรไฟล์',
            onboarding: 'การแนะนำการใช้งาน',
        },
        m_pricing_limit: {
            admin_roles: { title: 'ยกระดับการทำงานร่วมกันของคุณ', description: 'อัปเกรดเพื่อปลดล็อกบทบาทการแชร์เพิ่มเติม เช่น ผู้ดูแลระบบ ผู้แก้ไข ผู้แสดงความคิดเห็น และผู้ดู' },
            workspaces: { title: 'คุณกำลังเติบโตอย่างรวดเร็ว!', description: 'อัปเกรดเพื่อสร้างและจัดการพื้นที่ทำงานเพิ่มเติมสำหรับโปรเจกต์และทีมของคุณ' },
            workspaces_canvas: { title: 'ขยายพื้นที่ทำงานของคุณ', description: 'อัปเกรดเพื่อสร้างและจัดการพื้นที่ทำงานเพิ่มเติมสำหรับโปรเจกต์และทีมของคุณ' },
            members: { title: 'ทำงานร่วมกันในระดับใหญ่', description: 'อัปเกรดเพื่อเพิ่มสมาชิกเข้าสู่พื้นที่ทำงานและทำงานร่วมกันได้อย่างมีประสิทธิภาพยิ่งขึ้น' },
            diagrams: { title: 'คุณกำลังเติบโตอย่างรวดเร็ว!', description: 'อัปเกรดเพื่อสร้างไดอะแกรมเพิ่มเติมและพัฒนาโปรเจกต์ของคุณได้อย่างมั่นใจ' },
            tables: { title: 'สร้างได้โดยไม่มีขีดจำกัด', description: 'อัปเกรดเพื่อเพิ่มตารางและสร้างไดอะแกรมที่ใหญ่และละเอียดยิ่งขึ้นต่อไป' },
            columns: { title: 'สร้างได้โดยไม่มีขีดจำกัด', description: 'อัปเกรดเพื่อเพิ่มคอลัมน์และสร้างไดอะแกรมที่ใหญ่และละเอียดยิ่งขึ้นต่อไป' },
            notes: { title: 'สร้างได้โดยไม่มีขีดจำกัด', description: 'อัปเกรดเพื่อเพิ่มโน้ตและสร้างไดอะแกรมที่ใหญ่และละเอียดยิ่งขึ้นต่อไป' },
            areas: { title: 'สร้างได้โดยไม่มีขีดจำกัด', description: 'อัปเกรดเพื่อเพิ่มพื้นที่และสร้างไดอะแกรมที่ใหญ่และละเอียดยิ่งขึ้นต่อไป' },
            pens: { title: 'สร้างได้โดยไม่มีขีดจำกัด', description: 'อัปเกรดเพื่อเพิ่มภาพวาดและสร้างไดอะแกรมที่ใหญ่และละเอียดยิ่งขึ้นต่อไป' },
            default_title: 'ยกระดับการทำงานร่วมกันของคุณ',
            default_title_canvas: 'ยกระดับประสิทธิภาพของคุณ',
        },
        m_pricing_plans: {
            title: 'อัปเกรดแพ็กเกจของคุณ',
            subtitle: 'คุณสามารถอัปเกรดหรือดาวน์เกรดแพ็กเกจได้ทุกเมื่อ',
            monthly: 'รายเดือน',
            annually: 'รายปี',
            billed_annually: 'เรียกเก็บเงินรายปี',
            billed_monthly: 'เรียกเก็บเงินรายเดือน',
            free_for_everyone: 'ฟรีสำหรับทุกคน',
            current_plan: 'แพ็กเกจปัจจุบัน',
            will_be_available_soon: 'จะพร้อมใช้งานเร็ว ๆ นี้',
            price_period_user_month: '/ผู้ใช้/เดือน',
            plan_free: {
                name: 'ฟรี',
                button: 'เปลี่ยนแพ็กเกจ',
                feature_realtime: 'การทำงานร่วมกันแบบเรียลไทม์',
                feature_members: 'สมาชิก 4 คน / พื้นที่ทำงาน',
                feature_diagrams: 'ไดอะแกรม 4 รายการ / พื้นที่ทำงาน',
                feature_tables: 'ตาราง 40 รายการ / ไดอะแกรม',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'ฟีเจอร์ทั้งหมดของแพ็กเกจฟรี +',
                feature_members: 'สมาชิกไม่จำกัด',
                feature_diagrams: 'ไดอะแกรมไม่จำกัด',
                feature_tables: 'ตารางไม่จำกัด',
                feature_history: 'ประวัติเวอร์ชัน',
                feature_admin_roles: 'บทบาทผู้ดูแลระบบ',
            },
        },
        sidebar: {
            new: 'ใหม่',
            pinned_diagrams: 'ไดอะแกรมที่ปักหมุด',
            pin_hint: 'ปักหมุดไดอะแกรมเพื่อให้แสดงที่นี่',
            expand_sidebar: 'ขยายแถบด้านข้าง',
            home_aria: 'หน้าแรกของ DB Design',
            open_menu: 'เปิดเมนู',
            close_menu: 'ปิดเมนู',
            sidebar_menu_aria: 'เมนูแถบด้านข้าง',
            plan_suffix: 'แพ็กเกจ',
            diagram_options: 'ตัวเลือกไดอะแกรม',
            pin: 'ปักหมุด',
            unpin: 'ยกเลิกการปักหมุด',
            edit_details: 'แก้ไขรายละเอียด',
            see_details: 'ดูรายละเอียด',
            invite_people: 'เชิญ',
            collapse_sidebar: 'ยุบแถบด้านข้าง',
            close_sidebar: 'ปิดแถบด้านข้าง',
            open_sidebar: 'เปิดแถบด้านข้าง',
            open_new_tab: 'เปิดในแท็บใหม่',
        },
        focus_controls: {
            show_top: 'แสดงการควบคุมด้านบน',
            hide_top: 'ซ่อนการควบคุมด้านบน',
            show_left: 'แสดงการควบคุมด้านซ้าย',
            hide_left: 'ซ่อนการควบคุมด้านซ้าย',
        },
        m_keyboard_shortcuts: {
            title: 'ปุ่มลัดแป้นพิมพ์',
            general: {
                title1: 'ทั่วไป',
                title2: '',
                items: {
                    new_diagram: 'สร้างไดอะแกรม',
                    new_chat: 'แชทใหม่',
                    search: 'การดำเนินการด่วนหรือค้นหา',
                    preferences: 'การตั้งค่าที่ต้องการ',
                    settings: 'การตั้งค่า',
                    keyboard_shortcuts: 'ปุ่มลัดแป้นพิมพ์',
                    toggle_sidebar: 'สลับแถบด้านข้าง',
                    toggle_theme: 'สลับธีม',
                },
            },
            ctrl_left: {
                title1: 'การควบคุม',
                title2: '(ซ้าย)',
                items: {
                    mouse_sel: 'เลือกด้วยเมาส์ / โหมดมือ',
                    table: 'ตาราง',
                    line: 'เส้น',
                    area: 'พื้นที่',
                    note: 'โน้ต',
                    comment: 'ความคิดเห็น',
                    pen: 'ปากกา',
                    undo: 'เลิกทำ',
                    redo: 'ทำซ้ำ'
                },
            },
            ctrl_top_left: {
                title1: 'การควบคุม',
                title2: '(มุมซ้ายบน)',
                items: {
                    export_img: 'ส่งออกภาพ',
                    search: 'ค้นหา',
                    editor_panel: 'แผงตัวแก้ไข',
                    zoom_to_fit: 'ปรับพอดีกับหน้าจอ',
                },
            },
            ctrl_bottom_right: {
                title1: 'การควบคุม',
                title2: '(มุมขวาล่าง)',
                items: {
                    minimap: 'มินิแมป',
                    full_screen: 'เต็มหน้าจอ',
                    zoom_in: 'ขยาย',
                    zoom_out: 'ย่อ',
                    zoom_100: 'ซูม 100%'
                },
            },
            ctx_tab: {
                title1: 'เมนูตามบริบท',
                title2: '(ตาราง)',
                items: {
                    dupl_tab: 'ทำซ้ำตาราง',
                    del_tab: 'ลบตาราง'
                },
            },
            ctx_del_tab: {
                title1: 'เมนูตามบริบท',
                title2: '(ลบตาราง)',
                items: {
                    yes: 'ใช่',
                    no: 'ไม่ใช่'
                },
            },
            ctx_tab_col: {
                title1: 'เมนูตามบริบท',
                title2: '(คอลัมน์ของตาราง)',
                items: {
                    add_col_below: 'เพิ่มคอลัมน์ด้านล่าง',
                    focus_col_above: 'ย้ายโฟกัสไปยังคอลัมน์ด้านบน',
                    focus_col_below: 'ย้ายโฟกัสไปยังคอลัมน์ด้านล่าง',
                    move_col_up: 'ย้ายคอลัมน์ขึ้น',
                    move_col_down: 'ย้ายคอลัมน์ลง',
                    dupl_col: 'ทำซ้ำคอลัมน์',
                    del_col: 'ลบคอลัมน์'
                },
            },
            ctx_line: {
                title1: 'เมนูตามบริบท',
                title2: '(เส้น)',
                items: {
                    del_line: 'ลบเส้น'
                },
            },
            ctx_area: {
                title1: 'เมนูตามบริบท',
                title2: '(พื้นที่)',
                items: {
                    dupl_area: 'ทำซ้ำพื้นที่',
                    del_area: 'ลบพื้นที่'
                },
            },
            ctx_multi: {
                title1: 'เมนูตามบริบท',
                title2: '(เลือกหลายรายการ)',
                items: {
                    select_all: 'เลือกองค์ประกอบทั้งหมด',
                    create_area_for_select_els: 'สร้างพื้นที่สำหรับองค์ประกอบที่เลือก',
                    dupl_select_els: 'ทำซ้ำองค์ประกอบที่เลือก',
                    del_select_els: 'ลบองค์ประกอบที่เลือก'
                },
            },
        },
        t: {
            ctrl_left: {
                mouse_select: 'เลือกด้วยเมาส์',
                table: 'ตาราง',
                line: 'เส้น',
                area: 'พื้นที่',
                note: 'โน้ต',
                comment: 'ความคิดเห็น',
                pen: 'ปากกา',
                undo: 'เลิกทำ',
                redo: 'ทำซ้ำ'
            },
            ctrl_top_left: {
                home: 'หน้าแรก',
                name: 'ข้อมูลไดอะแกรม',
                editor: 'ตัวแก้ไข',
                search: 'การค้นหา',
                export: 'ตัวเลือกการส่งออก',
                view_mode: 'โหมดมุมมอง',
                zoom_to_fit: 'ปรับพอดีกับหน้าจอ',
                grid: 'โครงตาราง',
                history: 'ประวัติ',
                main_menu: 'เมนูหลัก',
                new_diagram: 'ไดอะแกรมใหม่',
            },
            ctrl_top_right: {
                feature_req: 'คำขอฟีเจอร์',
                feedback: 'ส่งความคิดเห็น',
                sign_in: 'ลงชื่อเข้าใช้',
                quick_share: 'แชร์ด่วน'
            },
            ctrl_bottom_right: {
                full_screen: 'เต็มหน้าจอ',
                minimap: 'มินิแมป',
                zoom_out: 'ย่อ',
                zoom_100: 'ซูม 100%',
                zoom_in: 'ขยาย',
                info: 'ข้อมูลและแหล่งข้อมูล'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'ค่าเริ่มต้น',
                        blue: 'สีน้ำเงิน',
                        green: 'สีเขียว',
                        red: 'สีแดง',
                        purple: 'สีม่วง',
                        violet: 'สีไวโอเลต'
                    },
                    borders: {
                        none: 'ไม่มี',
                        solid: 'เส้นทึบ',
                        dashed: 'เส้นประ',
                        dotted: 'เส้นจุด'
                    },
                    color: 'สี',
                    border: 'เส้นขอบ',
                    description: 'คำอธิบาย',
                    description_table_place: 'คำอธิบายตาราง',
                    description_column_place: 'คำอธิบายคอลัมน์',
                    description_line_place: 'คำอธิบายเส้น',
                    description_note_place: 'คำอธิบายโน้ต',
                    description_area_place: 'คำอธิบายพื้นที่',
                    description_pen_place: 'คำอธิบายปากกา',
                    hide_menu: 'ซ่อนเมนู',
                    show_menu: 'แสดงเมนู'
                },
                tab_col: {
                    add_col_below: 'เพิ่มคอลัมน์ด้านล่าง',
                    add_col_above: 'เพิ่มคอลัมน์ด้านบน',
                    key: 'Key',
                    keys: {
                        none: 'ไม่มี',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'ไม่มี',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'ย้ายคอลัมน์ลง',
                    move_col_up: 'ย้ายคอลัมน์ขึ้น',
                    more_functions: 'ฟังก์ชันเพิ่มเติม'
                },
                line: {
                    change_connects: 'เปลี่ยนตัวเชื่อมต่อ',
                    connects: {
                        empty: 'ว่าง',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'กรององค์ประกอบ'
                },
                note: {
                    link_placeholder: 'ป้อนลิงก์',
                    link_apply: 'เพิ่ม',
                    link_remove: 'นำออก',
                    link_edit: 'แก้ไข',
                    link_needs_selection: 'เลือกข้อความเพื่อใส่ลิงก์',
                    bulleted_list: 'รายการ',
                    numbered_list: 'รายการลำดับเลข',
                    font_style: 'รูปแบบตัวอักษร',
                    alignment: 'การจัดตำแหน่ง',
                    align_left: 'ชิดซ้าย',
                    align_center: 'กึ่งกลาง',
                    align_right: 'ชิดขวา',
                    link: 'ลิงก์',
                    monospace: 'ความกว้างเท่ากัน',
                    bold: 'ตัวหนา',
                    italic: 'ตัวเอียง',
                    underline: 'ขีดเส้นใต้',
                    strikethrough: 'ขีดฆ่า',
                },
                multi: {
                    filter: 'กรองการเลือก',
                    create_area: 'สร้างพื้นที่'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'เต็ม',
            keys_only: 'เฉพาะคีย์',
            names_only: 'เฉพาะชื่อ'
        },
        dropdown_ctrl_grid: {
            none: 'ไม่มี',
            lines: 'เส้น',
            dots: 'จุด',
        },
        dropdown_ctrl_export: {
            export_img: 'ส่งออกภาพ',
            export_code: 'ส่งออกโค้ด SQL'
        },
        dropdown_ctrl_settings: {
            back_home: 'กลับหน้าแรก',
            sign_in: 'ลงชื่อเข้าใช้',
            preferences: 'การตั้งค่าที่ต้องการ',
            new_project: 'โปรเจกต์ใหม่',
            import_diagram: 'นำเข้าไดอะแกรม',
            duplicate_diagram: 'ทำซ้ำไดอะแกรม',
            keyboard_shortcuts: 'ปุ่มลัดแป้นพิมพ์',
            languages: 'ภาษา',
            view: 'มุมมอง',
            upgrade_plan: 'อัปเกรดแพ็กเกจ',
            language: 'ภาษา',
            mouse_trackpad: 'เมาส์หรือแทร็กแพด',
            background_color: 'สีพื้นหลัง',
            grid_layout: 'โครงตาราง',
            view_mode: 'โหมดมุมมอง',
            show_align_lines: 'แสดงเส้นจัดแนว',
            show_members_cursors: 'แสดงเคอร์เซอร์ของสมาชิก',
            show_comments: 'แสดงความคิดเห็น',
            undo_redo_controls: 'การควบคุมเลิกทำ/ทำซ้ำ',
            show_scrollbars: 'แสดงแถบเลื่อน',
            opt_auto: 'อัตโนมัติ',
            opt_trackpad: 'แทร็กแพด',
            opt_mouse: 'เมาส์',
            opt_default: 'มืด (ค่าเริ่มต้น)',
            opt_gray: 'เทา',
            opt_blue: 'น้ำเงิน',
            opt_purple: 'ม่วง',
            opt_violet: 'ไวโอเลต',
            opt_green: 'เขียว',
            opt_red: 'แดง',
            opt_yellow: 'เหลือง',
            opt_dots: 'จุด',
            opt_lines: 'เส้น',
            opt_none: 'ไม่มี',
            opt_full: 'เต็ม',
            opt_keys: 'คีย์',
            opt_names: 'ชื่อ',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'ข้อเสนอแนะ',
            keyboard_shortcuts: 'ปุ่มลัดแป้นพิมพ์',
            languages: 'ภาษา',
            homepage: 'หน้าแรก'
        },
        n: {
            default: 'กำลังโหลด…',
            file_ready_to_download: 'ไฟล์พร้อมให้ดาวน์โหลดแล้ว',
            code_copied: 'คัดลอกโค้ดแล้ว',
            link_copied: 'คัดลอกลิงก์แล้ว',
            username_copied: 'คัดลอกชื่อผู้ใช้แล้ว',
            email_copied: 'คัดลอกอีเมลแล้ว',
            please_enter_message: 'โปรดป้อนข้อความ',
            invalid_email: 'อีเมลไม่ถูกต้อง',
            note_link_unsupported_protocol: 'ไม่รองรับประเภทลิงก์นี้ โปรดใช้ https, http หรือ mailto',
            something_wrong_contact: 'เกิดข้อผิดพลาด โปรดโหลดหน้าอีกครั้งหรือติดต่อเรา',
            something_wrong: 'เกิดข้อผิดพลาด โปรดโหลดหน้าอีกครั้ง',
            sending: 'กำลังส่ง…',
            request_sent: 'ส่งคำขอแล้ว ขอบคุณ!',

            please_enter_email: 'โปรดป้อนที่อยู่อีเมล',
            changing: 'กำลังเปลี่ยนแปลง...',
            role_changed: 'เปลี่ยนบทบาทแล้ว',
            removing: 'กำลังนำออก...',
            member_removed: 'นำสมาชิกออกแล้ว',
            inviting: 'กำลังเชิญ...',
            invite_sent: 'ส่งคำเชิญแล้ว',
            added_to_diagram: 'เพิ่มลงในไดอะแกรมแล้ว',
            invite_removed: 'ลบคำเชิญแล้ว',
            role_not_allowed_on_plan: 'บทบาทนี้ไม่รองรับในแพ็กเกจปัจจุบันของคุณ อัปเกรดเพื่อกำหนดบทบาทนี้',
            already_diagram_member: 'บุคคลนี้สามารถเข้าถึงไดอะแกรมนี้ได้อยู่แล้ว',
            cannot_invite_to_workspace: 'ให้ผู้ดูแลพื้นที่ทำงานเชิญบุคคลนี้เข้าร่วมพื้นที่ทำงาน',
            saving: 'กำลังบันทึก...',
            saved: 'บันทึกแล้ว',
            diagram_renamed: 'เปลี่ยนชื่อไดอะแกรมแล้ว',
            diagram_updated: 'อัปเดตไดอะแกรมแล้ว',
            duplicating: 'กำลังทำซ้ำ...',
            diagram_duplicated: 'ทำซ้ำไดอะแกรมแล้ว',
            deleting: 'กำลังลบ...',
            diagram_archived: 'เก็บถาวรไดอะแกรมแล้ว',
            diagram_deleted: 'ลบไดอะแกรมแล้ว',
            restoring: 'กำลังกู้คืน...',
            diagram_restored: 'กู้คืนไดอะแกรมแล้ว',
            diagram_pinned: 'ปักหมุดไดอะแกรมแล้ว',
            diagram_unpinned: 'ยกเลิกการปักหมุดไดอะแกรมแล้ว',
            creating: 'กำลังสร้าง...',
            diagram_created: 'สร้างไดอะแกรมแล้ว',
            forbidden: 'คุณไม่มีสิทธิ์เข้าถึงสิ่งนี้',
            invite_already_pending: 'บุคคลนี้มีคำเชิญที่รอดำเนินการอยู่แล้ว',
            already_member: 'เป็นสมาชิกพื้นที่ทำงานอยู่แล้ว',
            cannot_invite_self: 'คุณไม่สามารถเชิญตัวเองได้',
            workspace_not_found: 'ไม่พบพื้นที่ทำงาน โปรดรีเฟรชหน้าและลองอีกครั้ง',
            diagram_not_found: 'ไม่พบไดอะแกรม',
            has_diagram_members: 'ไดอะแกรมนี้มีสมาชิกที่ใช้งานอยู่',
            seat_limit_reached: 'คุณถึงขีดจำกัดจำนวนที่นั่งของแพ็กเกจแล้ว อัปเกรดเพื่อเชิญคนเพิ่มเติม',
            feature_not_in_plan: 'ฟีเจอร์นี้ไม่รวมอยู่ในแพ็กเกจปัจจุบันของคุณ',
            subscription_expired: 'การสมัครสมาชิกของคุณหมดอายุแล้ว โปรดต่ออายุเพื่อใช้งานต่อ',
            subscription_inactive: 'การสมัครสมาชิกของคุณไม่ได้ใช้งานอยู่ โปรดอัปเดตการเรียกเก็บเงิน',
            plan_limit_generic: 'แพ็กเกจของคุณไม่อนุญาตให้ดำเนินการนี้ อัปเกรดเพื่อดำเนินการต่อ',

            // Auth / profile
            session_expired: 'เซสชันของคุณหมดอายุแล้ว — โปรดลงชื่อเข้าใช้อีกครั้ง',
            profile_updated: 'อัปเดตโปรไฟล์แล้ว',
            profile_update_failed: 'อัปเดตโปรไฟล์ไม่สำเร็จ',
            account_delete_failed: 'ลบบัญชีไม่สำเร็จ',

            // Preferences
            couldnt_save: 'ไม่สามารถบันทึกการเปลี่ยนแปลงได้',
            try_again: 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง',

            // Workspace
            not_workspace_member: 'คุณไม่ใช่สมาชิกของพื้นที่ทำงานนั้น',
            workspace_switch_failed: 'ไม่สามารถสลับพื้นที่ทำงานได้ โปรดลองอีกครั้ง',
            workspace_create_failed: 'ไม่สามารถสร้างพื้นที่ทำงานได้ โปรดลองอีกครั้ง',
            invalid_workspace_name: 'ชื่อพื้นที่ทำงานไม่ถูกต้อง',
            workspace_updated: 'อัปเดตพื้นที่ทำงานแล้ว',
            workspace_update_failed: 'ไม่สามารถอัปเดตพื้นที่ทำงานได้ โปรดลองอีกครั้ง',
            last_owner_cannot_leave: 'คุณเป็นเจ้าของเพียงคนเดียว โปรดตั้งให้ผู้อื่นเป็นเจ้าของ หรือลบพื้นที่ทำงานก่อนที่จะออก',
            workspace_leave_failed: 'ไม่สามารถออกจากพื้นที่ทำงานได้ โปรดลองอีกครั้ง',
            workspace_delete_forbidden: 'เฉพาะเจ้าของพื้นที่ทำงานเท่านั้นที่สามารถลบพื้นที่ทำงานนี้ได้',
            workspace_has_active_billing: 'โปรดยกเลิกการสมัครสมาชิกของพื้นที่ทำงานนี้ก่อนลบ',
            workspace_deleted: 'ลบพื้นที่ทำงานแล้ว',
            workspace_delete_failed: 'ไม่สามารถลบพื้นที่ทำงานได้ โปรดลองอีกครั้ง',
            member_remove_forbidden: 'คุณไม่มีสิทธิ์นำสมาชิกนี้ออก',
            member_remove_failed: 'ไม่สามารถนำสมาชิกออกได้ โปรดลองอีกครั้ง',
            cannot_remove_self: 'ใช้ "ออกจากพื้นที่ทำงาน" เพื่อนำตัวเองออก',
            cannot_remove_last_owner: 'พื้นที่ทำงานต้องมีเจ้าของเสมอ โปรดตั้งให้ผู้อื่นเป็นเจ้าของก่อน',
            invite_revoke_forbidden: 'คุณไม่มีสิทธิ์ยกเลิกคำเชิญนี้',
            invite_revoke_failed: 'ไม่สามารถยกเลิกคำเชิญได้ โปรดลองอีกครั้ง',
        },
        dashboard: {
            doc_title: 'ไดอะแกรม',
            filter_all: 'ทั้งหมด',
            filter_mydiagrams: 'ไดอะแกรมของฉัน',
            filter_shared: 'แชร์กับฉัน',
            filter_archived: 'เก็บถาวรแล้ว',
            empty_all: 'ไม่มีไดอะแกรมใน "ไดอะแกรมทั้งหมด"',
            empty_mydiagrams: 'ไม่มีไดอะแกรมใน "ไดอะแกรมของฉัน"',
            empty_shared: 'ไม่มีไดอะแกรมใน "แชร์กับฉัน"',
            empty_archived: 'ไม่มีไดอะแกรมใน "เก็บถาวรแล้ว"',
            example_diagram_badge: 'ไดอะแกรมตัวอย่าง',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'กลับสู่แอป',
                group_personal: 'ส่วนตัว',
                group_organization: 'องค์กร',
                billing: 'การเรียกเก็บเงิน',
            },
            profile: {
                member_since: 'สมาชิกตั้งแต่ {{date}}',
                general: 'ทั่วไป',
                email: 'อีเมล',
                full_name: 'ชื่อ-นามสกุล',
                full_name_placeholder: 'กรอกชื่อ',
                account_protection: 'การปกป้องบัญชี',
                mfa_label: 'การยืนยันตัวตนหลายปัจจัย (MFA)',
                mfa_sub: 'ชั้นความปลอดภัยเพิ่มเติมสำหรับบัญชี · เร็ว ๆ นี้',
                mfa_enable: 'เปิดใช้งาน MFA',
                mfa_soon_tooltip: 'จะเปิดให้ใช้งานเร็ว ๆ นี้',
                workspace_access: 'สิทธิ์เข้าถึงพื้นที่ทำงาน',
                leave_workspace: 'ออกจากพื้นที่ทำงาน',
                leave_workspace_sub: 'นำคุณออกจากพื้นที่ทำงาน',
                leave_owner_tooltip: 'โอนความเป็นเจ้าของก่อนออกจากพื้นที่ทำงาน',
            },
            workspace: {
                header: 'พื้นที่ทำงาน',
                general: 'ทั่วไป',
                name_label: 'ชื่อพื้นที่ทำงาน',
                name_placeholder: 'ชื่อพื้นที่ทำงาน',
                stat_member_singular: 'สมาชิก',
                stat_member_plural: 'สมาชิก',
                stat_team_singular: 'ทีม',
                stat_team_plural: 'ทีม',
                members_section: 'สมาชิก',
                no_members: 'ไม่มีสมาชิก',
                count_member_singular: 'สมาชิก',
                count_member_plural: 'สมาชิก',
                view_members_btn: 'ดูสมาชิก',
                danger_zone: 'โซนอันตราย',
                delete_workspace: 'ลบพื้นที่ทำงาน',
                delete_workspace_sub: 'การดำเนินการนี้จะลบพื้นที่ทำงานอย่างถาวร',
                delete_owner_only_tooltip: 'เฉพาะเจ้าของเท่านั้นที่สามารถลบพื้นที่ทำงานได้',
                delete_cancel_sub_tooltip: 'โปรดยกเลิกการสมัครสมาชิกก่อนลบพื้นที่ทำงาน',
            },
            members: {
                header: 'สมาชิก',
                col_name: 'ชื่อ',
                col_email: 'อีเมล',
                col_role: 'บทบาท',
                col_joined: 'เข้าร่วมเมื่อ',
                active_members: 'สมาชิกที่ใช้งานอยู่',
                invited_section: 'ได้รับเชิญ',
                no_members: 'ยังไม่มีสมาชิก',
                options_aria: 'ตัวเลือก',
                leave_workspace_item: 'ออกจากพื้นที่ทำงาน...',
                remove_member_item: 'ลบสมาชิก...',
                remove_owner_only_tooltip: 'เฉพาะเจ้าของเท่านั้นที่สามารถลบสมาชิกได้',
                remove_owner_row_tooltip: 'ไม่สามารถลบเจ้าของออกจากพื้นที่ทำงานได้',
                remove_invite_item: 'ลบคำเชิญ...',
                role_invited_suffix: '{{role}} (ได้รับเชิญ)',
            },
            preferences: {
                section_general: 'ทั่วไป',
                section_diagram_defaults: 'การตั้งค่าไดอะแกรม',
                section_diagram_views: 'มุมมองไดอะแกรม',
                section_notifications: 'การแจ้งเตือน',
                theme_label: 'ธีมอินเทอร์เฟซ',
                theme_sub: 'เลือกโทนสีของอินเทอร์เฟซของคุณ',
                theme_dark: 'มืด',
                theme_light: 'สว่าง',
                theme_system: 'ตามระบบ',
                language_sub: 'เลือกภาษาของอินเทอร์เฟซของคุณ',
                timezone_label: 'เขตเวลา',
                timezone_sub: 'เลือกเขตเวลาของคุณ',
                timezone_options: {
                    honolulu: 'GMT-10:00 — ฮาวาย',
                    anchorage: 'GMT-09:00 — อะแลสกา',
                    los_angeles: 'GMT-08:00 — เวลาแปซิฟิก',
                    denver: 'GMT-07:00 — เวลาเทือกเขา',
                    chicago: 'GMT-06:00 — เวลาตอนกลาง',
                    new_york: 'GMT-05:00 — เวลาตะวันออก',
                    caracas: 'GMT-04:00 — การากัส',
                    sao_paulo: 'GMT-03:00 — เซาเปาโล',
                    azores: 'GMT-01:00 — อาซอเรส',
                    london: 'GMT+00:00 — ลอนดอน',
                    paris: 'GMT+01:00 — ปารีส เบอร์ลิน',
                    kyiv: 'GMT+02:00 — เคียฟ เอเธนส์',
                    istanbul: 'GMT+03:00 — อิสตันบูล',
                    dubai: 'GMT+04:00 — ดูไบ',
                    karachi: 'GMT+05:00 — การาจี',
                    kolkata: 'GMT+05:30 — อินเดีย',
                    dhaka: 'GMT+06:00 — ธากา',
                    bangkok: 'GMT+07:00 — กรุงเทพฯ จาการ์ตา',
                    shanghai: 'GMT+08:00 — ปักกิ่ง สิงคโปร์',
                    tokyo: 'GMT+09:00 — โตเกียว โซล',
                    sydney: 'GMT+10:00 — ซิดนีย์',
                    auckland: 'GMT+12:00 — โอ๊คแลนด์',
                },
                input_mode_sub: 'เลือกการควบคุมการนำทางแคนวาส',
                background_sub: 'เลือกสีพื้นหลังสำหรับแคนวาส',
                grid_sub: 'เลือกรูปแบบตารางของแคนวาส',
                show_align_lines_sub: 'แสดงเส้นเมื่อจัดแนวออบเจ็กต์',
                show_cursors_sub: 'แสดงเคอร์เซอร์ของผู้ร่วมงานคนอื่น',
                show_comments_sub: 'แสดงความคิดเห็นบนแคนวาส',
                show_scrollbars_sub: 'แสดงแถบเลื่อนขณะนำทางแคนวาส',
                show_undo_redo_label: 'แสดงตัวควบคุมเลิกทำ/ทำซ้ำ',
                show_undo_redo_sub: 'แสดงตัวควบคุมสำหรับเลิกทำและทำซ้ำการเปลี่ยนแปลง',
                notif_shared_label: 'ไดอะแกรมที่แชร์กับฉัน',
                notif_shared_sub: 'เมื่อมีคนแชร์ไดอะแกรมกับฉัน',
                notif_mentions_label: 'การกล่าวถึงในความคิดเห็น',
                notif_mentions_sub: 'เมื่อมีคนแท็ก @ฉันในความคิดเห็น',
                notif_updates_label: 'อัปเดตผลิตภัณฑ์',
                notif_updates_sub: 'อัปเดตรายเดือนเกี่ยวกับฟีเจอร์ใหม่และการปรับปรุง',
                show: 'แสดง',
                hide: 'ซ่อน',
                on: 'เปิด',
                off: 'ปิด',
            },
            billing: {
                header: 'การเรียกเก็บเงิน',
                plan_free: 'แพ็กเกจฟรี',
                status_current: 'ปัจจุบัน',
                no_renewal_needed: 'ไม่จำเป็นต้องต่ออายุ',
                payment_header: 'การชำระเงิน',
                no_payments: 'ไม่มีการชำระเงิน',
                invoices_header: 'ใบแจ้งหนี้',
                no_invoices: 'ไม่มีใบแจ้งหนี้',
            },
            usage: {
                doc_title: 'การใช้งาน',
                overview_title: 'ภาพรวม',
                resource_limits_title: 'ขีดจำกัดทรัพยากร',
                label_diagrams: 'ไดอะแกรม',
                label_tables: 'ตาราง',
                label_areas: 'พื้นที่',
                label_notes: 'สติกกี้โน้ต',
                label_members: 'สมาชิก',
                label_tables_per_diagram: 'ตาราง / ไดอะแกรม',
                label_areas_per_diagram: 'พื้นที่ / ไดอะแกรม',
                label_notes_per_diagram: 'โน้ต / ไดอะแกรม',
                need_more_title: 'ต้องการเพิ่มเติมหรือไม่',
                need_more_free: 'อัปเกรดเป็น Basic เพื่อไดอะแกรมเพิ่มเติม ประวัติเวอร์ชัน และการสนับสนุนแบบเร่งด่วน',
                need_more_paid: 'อัปเกรดเป็น Professional เพื่อไดอะแกรมไม่จำกัด ที่นั่งไม่จำกัด และฟีเจอร์ขั้นสูง',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'ไม่พบหน้านี้',
                dont_have_access_to_diagram: 'คุณไม่มีสิทธิ์เข้าถึงไดอะแกรมนี้ หรืออาจไม่มีอยู่อีกต่อไป',
                back_home: 'กลับหน้าแรก'
            },
            error: {
                title: 'ข้อผิดพลาด',
                link_is_invalid: 'ลิงก์นี้ไม่ถูกต้องหรือป้อนไม่ถูกต้อง',
                something_wrong: 'เกิดข้อผิดพลาด',
                back_home: 'กลับหน้าแรก',
                please_try_later: 'โปรดลองอีกครั้งในภายหลัง',
            },
            billing_success: {
                doc_title: 'อัปเกรดแพ็กเกจแล้ว',
                heading: 'ชำระเงินสำเร็จ',
                subtitle: 'แพ็กเกจของคุณได้รับการอัปเกรดเรียบร้อยแล้ว',
                cta: 'เริ่มออกแบบ',
            },
            email_verified: {
                doc_title: 'ยืนยันอีเมลแล้ว',
            },
            forgot_password: {
                doc_title: 'ลืมรหัสผ่าน',
            },
            password_updated: {
                doc_title: 'อัปเดตรหัสผ่านแล้ว',
            },
            reset_password: {
                doc_title: 'รีเซ็ตรหัสผ่าน',
            },
            check_email: {
                doc_title: 'ตรวจสอบอีเมลของคุณ',
            },
            sign_in: {
                doc_title: 'เข้าสู่ระบบ {{product}}',
            },
            sign_up: {
                doc_title: 'สมัครใช้งาน {{product}}',
            },
        },
    },
};

export const thMeta = {
    lang_origin: 'ภาษาไทย',
    lang_eng: 'Thai',
    lang_code: 'th',
};
